/**
 * Section configuration for each component type.
 * Each component type defines which sections to render and in what order.
 *
 * Section order convention:
 * 1. Unique/type-specific sections first (shape type, text formatting, media source)
 * 2. Common sections after (appearance: style with background + border, opacity)
 *
 * AppearanceSection renders a unified "Style" section containing:
 * - Background color (showBackgroundColor)
 * - Border radius (showBorderRadius)
 * - Border width (showBorderWidth)
 * - Border color (showBorderColor)
 * - Opacity (showOpacity) - rendered separately below Style section
 */

export const COMPONENT_SECTIONS_CONFIG = {
    text: {
        sections: ['typography', 'appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: false,
            showBorderColor: false,
            showOpacity: true
        }
    },
    bullets: {
        sections: ['typography', 'appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: false,
            showBorderColor: false,
            showOpacity: true
        }
    },
    shape: {
        sections: ['shapeType', 'appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: true,
            showBorderColor: true,
            showOpacity: true
        }
    },
    image: {
        sections: ['mediaSource', 'appearance'],
        appearance: {
            showBackgroundColor: false,
            showBorderRadius: true,
            showBorderWidth: false,
            showBorderColor: false,
            showOpacity: true
        }
    },
    video: {
        sections: ['mediaSource', 'appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: true,
            showBorderColor: true,
            showOpacity: true
        }
    },
    logo: {
        sections: ['appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: true,
            showBorderColor: true,
            showOpacity: true
        }
    },
    backgroundImage: {
        sections: ['mediaSource', 'removeBackground', 'appearance'],
        appearance: {
            showBackgroundColor: false,
            showBorderRadius: true,
            showBorderWidth: false,
            showBorderColor: false,
            showOpacity: true
        }
    },
    backgroundVideo: {
        sections: ['mediaSource', 'removeBackground', 'appearance'],
        appearance: {
            showBackgroundColor: true,
            showBorderRadius: true,
            showBorderWidth: false,
            showBorderColor: false,
            showOpacity: true
        }
    }
};